import React, { forwardRef } from 'react'

import styles from './_scrolling-container.module.scss'

type ScrollingContainerProps = {
  /** The content to be shown inside the component. */
  children: React.ReactNode
  /** Height of the container */
  height?: number | string
  /** Optionally hide the top and bottom gradients */
  hideGradients?: boolean
  /** Optionally use `position: absolute` instead of `position: sticky` */
  position?: 'absolute' | 'sticky'
  /** Optional prop to add a test id to the ScrollingContainer for QA testing */
  qaTestId?: string
}

const ScrollingContainer = forwardRef<HTMLDivElement, ScrollingContainerProps>(
  (
    {
      children,
      hideGradients,
      height = 300,
      position = 'sticky',
      qaTestId = 'scrolling-container',
    },
    ref,
  ): React.JSX.Element => {
    return (
      <div
        className={styles.scrollingContainer}
        style={{ height }}
        ref={ref}
        qa-test-id={qaTestId}
      >
        {!hideGradients ? (
          <div className={`${styles.topGradient} ${styles[position]}`} />
        ) : null}
        <div>{children}</div>
        {!hideGradients ? (
          <div className={`${styles.bottomGradient} ${styles[position]}`} />
        ) : null}
      </div>
    )
  },
)

ScrollingContainer.displayName = 'ScrollingContainer'
export default ScrollingContainer
